import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
  SvgIconProps,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { closingConditionsLevel } from '@roc/feature-utils';
import { Help } from '@material-ui/icons';
import { ReactElement, ReactNode } from 'react';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      whiteSpace: 'pre-line',
      fontSize: theme.typography.pxToRem(14),
      maxWidth: '75vw',
    },
    closingConditionTooltip: {
      whiteSpace: 'pre-line',
      fontSize: theme.typography.pxToRem(14),
      maxWidth: '240px',
      backgroundColor: '#AB4B54'
    },
    closingConditionTooltipWarning: {
      whiteSpace: 'pre-line',
      fontSize: theme.typography.pxToRem(14),
      maxWidth: '240px',
      backgroundColor: 'rgb(221, 167, 0)'
    },
    closingConditionArrow: {
      color: '#AB4B54'
    },
    closingConditionArrowWarning: {
      color: 'rgb(221, 167, 0)'
    },
    helpIcon: {
      height: '18px',
      width: '18px',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
  })
);

export interface IconProps extends SvgIconProps { }

export interface TooltipProps extends Omit<MuiTooltipProps, 'children'> {
  children?: ReactElement;
  iconColor?: SvgIconProps['color'];
  placement?: 'right' | 'left' | 'top' | 'bottom' | 'bottom-end';
  closingCondition?: boolean
  closingConditionLevel?: number
}

export const Tooltip = (props: TooltipProps) => {
  const {
    children,
    placement,
    closingCondition = false,
    iconColor = 'primary',
    closingConditionLevel,
    ...muiTooltipProps
  } = props;
  const classes = useStyle();
  let ccLevelClass = classes.closingConditionTooltip;
  let ccArrowClass = classes.closingConditionArrow;
  if (closingCondition && closingConditionLevel === closingConditionsLevel.LEVEL_1) {
    ccLevelClass = classes.closingConditionTooltipWarning;
    ccArrowClass = classes.closingConditionArrowWarning;
  }

  return (
    <MuiTooltip
      placement={placement || 'right'}
      classes={{ tooltip: closingCondition ? ccLevelClass : classes.tooltip, arrow: closingCondition ? ccArrowClass : '' }}
      {...muiTooltipProps}
    >
      {children ?? <Help className={classes.helpIcon} color={iconColor} />}
    </MuiTooltip>
  );
};
